const apiUrl = process.env.URL_API || "http://localhost:8080";

const getJwtToken = () => {
    const token = localStorage.getItem('jwtToken');
    if (!token || token.split('.').length !== 3) {
        throw new Error('Invalid JWT token');
    }
    return token;
};
const sendMessage = async (recipientNumber, variables) => {
    const token = getJwtToken(); // Obtém o token
    const url = `${apiUrl}/clinica-integrada/api/messages/send?contato=${recipientNumber}`; // Rota Java
    const body = JSON.stringify({
        variables
    });
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: body
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const ApiTallos = {
    sendMessage
};
